import { once } from 'lodash'
import QRCode from 'qrcode'

import { RequestedAnnualReportFragment } from '@/generated/graphql'

export const getAnnualReportBackgroundImageUrl = (index: number) =>
  `https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/backgrounds/annual-report-${index + 1}.jpg` +
  '?_=' +
  Math.round(Math.random() * 1000000)

export const drawAnnualReportPage = (
  ctx: CanvasRenderingContext2D,
  image: HTMLImageElement,
  fontName: string,
  index: number,
  annualReport: RequestedAnnualReportFragment,
  name: string
) => {
  const width = 640
  const paddingWidth = 40
  const lineHeight = 32
  const paragraphSpan = 40
  ctx.drawImage(image, 0, 0)
  ctx.font = `${lineHeight}px ${fontName}`
  ctx.fillStyle = 'white'
  const highlightColor = '#fae49a'

  const params = {
    ctx,
    x: paddingWidth,
    width: width - paddingWidth * 2,
    lineHeight,
  }
  let axisY
  const qrCodeX = 245
  const qrCodeY = 800
  const qrMessageX = 200
  const qrMessageY = 775
  const saveMessageX = 130
  const saveMessageY = 980
  let qrCode
  if ([9, 10, 11, 12, 13, 14].includes(index)) {
    qrCode = document.createElement('canvas')
    const url =
      (window.location.origin.includes('localhost:8080') ? 'https://t.agoralab.co' : window.location.origin) +
      '/annual-report'
    QRCode.toCanvas(qrCode, url, { errorCorrectionLevel: 'L' })
  }

  switch (index) {
    case 1: {
      const [year, month] = annualReport.firstLandingDate.split('-')
      const postDate = annualReport.firstPostingDate?.split('-')
      let axisY = 200
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [{ content: `Hi ${name},` }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [
          { content: `时光荏苒，` },
          { content: `${year}年${Number(month)}月`, color: highlightColor },
          { content: '，你抵达Tale星球，开启奇幻之旅。' },
        ],
      })
      const contents = postDate
        ? [
            { content: `${Number(postDate[1])}月${Number(postDate[2])}日`, color: highlightColor },
            { content: '，你写下第一段人类的语言，文字背后的心情我不得而知，但依然很开心，和你有了这样第一次的对话。' },
          ]
        : [{ content: '很开心，和你有了第一次相遇，让温情的联结多了一个节点。' }]

      drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents,
      })

      return true
    }
    case 2: {
      let axisY = 220
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [{ content: '过去一年，Tale星球围绕着 ' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [
          { content: 'Connecting talents, Telling tales', color: highlightColor },
          { content: ' 的使命公转自转。' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [
          {
            content: '战略官宣、文化印记、工作生活，大事小事，沟通对话，在',
          },
          {
            content: `${annualReport.totalGroupCount}个`,
            color: highlightColor,
          },
          {
            content: '群组中自由流通。',
          },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '知识库、个人主页、周年“网龄”贺卡，功能上新，提高效率，也要传递温度。' }],
      })
      drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [
          { content: '思维的火花在 ' },
          { content: 'Lightning Talks & Thunder Talks', color: highlightColor },
          { content: ' 碰撞，创新的点子埋下了小小的芽。' },
        ],
      })
      return true
    }
    case 3: {
      let axisY = 300
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [{ content: '信息宇宙，瀚海如烟。有你的陪伴，   Tale星球有了引擎加速度，不断更新迭代。' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '作为回礼，Tale用心收藏了你留在这里的每次痕迹，' }],
      })
      drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '我们一起回顾，星球上属于你的吉光片羽～' }],
      })
      return true
    }
    case 4: {
      let axisY = 200
      const hasPostContent = annualReport.totalPostCount >= 2
      const hasCommentContent = annualReport.totalPostCommentCount >= 3
      const hasLikedContent = annualReport.totalPostLikedCount >= 3

      if (!hasPostContent && !hasLikedContent && !hasCommentContent) {
        axisY = drawContent({
          ...params,
          y: axisY,
          contents: [{ content: '星球声友们的日常记录和点滴想法，' }],
        })
        axisY = drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [{ content: '捕捉着工作里的趣味和闪光。' }],
        })
        axisY = drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [
            { content: '过去的时光，你有' },
            { content: `${annualReport.totalLandingDateCount}天`, color: highlightColor },
            { content: '登录了Tale星球' },
            { content: `${annualReport.totalLandingCount}次`, color: highlightColor },
            { content: '。' },
          ],
        })
        axisY = drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [{ content: '还没有留下属于你的更多声音，' }],
        })
        axisY = drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [{ content: '友邻们期待与你有更多互动。' }],
        })
      } else {
        axisY = drawContent({
          ...params,
          y: axisY,
          contents: [
            { content: '过去的时光，你有' },
            { content: `${annualReport.totalLandingDateCount}天`, color: highlightColor },
            { content: '共登录了Tale星球' },
            { content: `${annualReport.totalLandingCount}次`, color: highlightColor },
            { content: '。' },
          ],
        })
        if (hasPostContent) {
          axisY = drawContent({
            ...params,
            y: axisY + paragraphSpan,
            contents: [
              {
                content: '细数起来，你在星球发了',
              },
              {
                content: `${annualReport.totalPostCount}个`,
                color: highlightColor,
              },
              {
                content: '帖子，留下了',
              },
              { content: `${annualReport.totalPostCount}个`, color: highlightColor },
              { content: '脚印，回头看，是一段坚实而有收获的旅程。' },
            ],
          })
        }

        if (hasCommentContent) {
          axisY = drawContent({
            ...params,
            y: axisY + paragraphSpan,
            contents: [
              { content: '你还经常去其他声友家“踩踩”，留下了' },
              { content: `${annualReport.totalPostCommentCount}个`, color: highlightColor },
              { content: '对话小气泡。' },
            ],
          })
        }

        if (hasLikedContent) {
          drawContent({
            ...params,
            y: axisY + paragraphSpan,
            contents: [
              { content: '你对非常感兴趣的大事小情，毫不隐藏赞美之情！' },
              { content: `${annualReport.totalPostLikedCount}个`, color: highlightColor },
              { content: '赞，是你对其他伙伴的认可和喜爱～' },
            ],
          })
        }
      }
      return true
    }
    case 5: {
      let axisY = 250
      const hasFollowGroupContent = annualReport.totalFollowedGroupCount >= 3
      const hasFollowEachOtherContent = annualReport.totalFollowedEachOtherCount >= 3
      const hasCommonGroup = annualReport.totalCommonGroupWithWorkCircleCount.length > 0
      if (hasFollowGroupContent && hasFollowEachOtherContent) {
        axisY = drawContent({
          ...params,
          y: axisY,
          contents: [
            { content: '在Tale星球，你加入了' },
            { content: `${annualReport.totalFollowedGroupCount}个`, color: highlightColor },
            { content: '群组。' },
          ],
        })
        axisY = drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [
            { content: '在这些站点，你结交了' },
            { content: `${annualReport.totalFollowedEachOtherCount}名`, color: highlightColor },
            { content: '同行者。' },
          ],
        })
      }

      if (hasCommonGroup) {
        axisY = drawContent({
          ...params,
          y: hasFollowGroupContent && hasFollowEachOtherContent ? axisY + paragraphSpan : axisY,
          contents: [
            { content: `${annualReport.totalCommonGroupWithWorkCircleCount[0].name}群组`, color: highlightColor },
            { content: '，是你和协同圈好友们共同关注最多的站点。' },
          ],
        })
        drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [
            { content: '除了协同圈的小伙伴，那里还有' },
            {
              content: `${annualReport.totalCommonGroupWithWorkCircleCount[0].followers.totalCount}名`,
              color: highlightColor,
            },
            { content: '声友，一起分享心情，交流工作，提供建议！' },
          ],
        })
      }
      return (hasFollowGroupContent && hasFollowEachOtherContent) || hasCommonGroup
    }
    case 6: {
      let axisY = 400
      const hasOkrContent = annualReport.okr.total >= 1
      const hasParticipatedContent = annualReport.project.participatedCount >= 1
      const hasOwnedContent = annualReport.project.ownedCount >= 1
      if (hasOkrContent) {
        axisY = drawContent({
          ...params,
          y: axisY,
          contents: [
            { content: 'Tale星球还记录下了你奋斗的身影，在2021，你创建了' },
            { content: `${annualReport.okr.total}个`, color: highlightColor },
            { content: 'OKR' },
          ],
        })
      }
      if (hasParticipatedContent || hasOwnedContent) {
        const participatedContents = hasParticipatedContent
          ? [
              { content: '为了向目标前进，你参与了' },
              { content: `${annualReport.project.participatedCount}个`, color: highlightColor },
              { content: '项目' },
            ]
          : []

        const ownedContents = hasOwnedContent
          ? [
              { content: hasParticipatedContent ? '，主导了' : '为了向目标前进，你主导了' },
              { content: `${annualReport.project.ownedCount}个`, color: highlightColor },
              { content: '项目的完成，' },
            ]
          : []
        axisY = drawContent({
          ...params,
          y: hasOkrContent ? axisY : axisY + paragraphSpan,
          contents: [...participatedContents, ...ownedContents],
        })
      }
      if (hasOkrContent || hasParticipatedContent || hasOwnedContent) {
        drawContent({
          ...params,
          y: axisY + paragraphSpan,
          contents: [{ content: '你的贡献，在这里留下了痕迹！' }],
        })
      }

      return hasOkrContent || hasParticipatedContent || hasOwnedContent
    }
    case 7: {
      let axisY = 450
      const hasEventContents = annualReport.totalEventParticipatedCount >= 1
      const contents = hasEventContents
        ? [
            { content: '哦！你还报名参加了' },
            { content: `${annualReport.totalEventParticipatedCount}场`, color: highlightColor },
            { content: '星球会议，当时的收获你还有印象吗？' },
          ]
        : [{ content: '过去一年，43场星球活动汇聚着好奇好学的声友们，期待未来也能看见你的身影！' }]

      axisY = drawContent({
        ...params,
        y: axisY,
        contents,
      })

      drawContent({
        ...params,
        y: hasEventContents ? axisY + paragraphSpan : axisY,
        contents: [
          { content: '在' },
          {
            content: `${Number(annualReport.highestRateLandingDate?.split('-')[1])}月${Number(
              annualReport.highestRateLandingDate?.split('-')[2]
            )}日`,
            color: highlightColor,
          },
          { content: '你在Tale上登录了最多次，那一天是哪个星球大事件吸引了你？' },
        ],
      })
      return true
    }
    case 8: {
      axisY = drawContent({
        ...params,
        y: 300,
        contents: [{ content: '哇！' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '不知不觉，Tale星球能拥有这么多属于你的印记！' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: 'Tale星球还在不断进化，上面的一草一木，一朵小花，都是你的灵感给予的养分' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '希望你常来看看，留下更多属于我们的珍贵回忆！' }],
      })
      drawContent({
        ...params,
        y: axisY + paragraphSpan * 2,
        contents: [{ content: '正在生成你的飞行记录……' }],
      })
      return true
    }
    case 9: {
      axisY = drawContent({
        ...params,
        y: 500,
        lineLimit: 18,
        contents: [
          { content: '过去一年，你在星球发了' },
          { content: `${annualReport.totalPostCount}个`, color: highlightColor },
          { content: '帖子，留下了' },
          { content: `${annualReport.totalPostCount}个`, color: highlightColor },
          { content: '脚印，超过' },
          { content: `95%`, color: highlightColor },
          { content: '飞行家' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '是你的智慧、洞见与分享欲，让信息透明源源不断' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: 'Tale星球，因你更具生命力' }],
      })
      if (qrCode) {
        ctx.font = `24px ${fontName}`
        ctx.fillText('扫码生成你的年度报告', qrMessageX, qrMessageY)
        ctx.drawImage(qrCode, qrCodeX, qrCodeY)
        ctx.fillText('长按即可分享或保存你的飞行身份哦', saveMessageX, saveMessageY)
        ctx.font = `${lineHeight}px ${fontName}`
      }
      return true
    }
    case 10: {
      axisY = drawContent({
        ...params,
        y: 500,
        contents: [
          { content: '过去一年，你留下了' },
          { content: `${annualReport.totalPostCommentCount}条`, color: highlightColor },
          { content: '评论，' },
          { content: `${annualReport.totalPostLikedCount}个`, color: highlightColor },
          { content: '赞，超过' },
          { content: '95%', color: highlightColor },
          { content: '飞行家' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '是你和声友的共鸣互动，为我们带来了看待世界、解决问题的不同视角' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '连接彼此的社区氛围，有你作为“气氛组”的大力贡献！' }],
      })
      if (qrCode) {
        ctx.font = `24px ${fontName}`
        ctx.fillText('扫码生成你的年度报告', qrMessageX, qrMessageY)
        ctx.drawImage(qrCode, qrCodeX, qrCodeY)
        ctx.fillText('长按即可分享或保存你的飞行身份哦', saveMessageX, saveMessageY)
        ctx.font = `${lineHeight}px ${fontName}`
      }
      return true
    }
    case 11: {
      axisY = drawContent({
        ...params,
        y: 500,
        contents: [
          { content: '过去一年，你有' },
          { content: `${annualReport.totalLandingDateCount}天`, color: highlightColor },
          { content: '登录了Tale星球' },
          { content: `${annualReport.totalLandingCount}次`, color: highlightColor },
          { content: '，超过' },
          { content: '95%', color: highlightColor },
          { content: '飞行家' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '你是Tale的飞行常客，星球上的信息沉淀和内容创作，因你的看见，更加熠熠生辉' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '欢迎你常来，起飞~' }],
      })
      if (qrCode) {
        ctx.font = `24px ${fontName}`
        ctx.fillText('扫码生成你的年度报告', qrMessageX, qrMessageY)
        ctx.drawImage(qrCode, qrCodeX, qrCodeY)
        ctx.fillText('长按即可分享或保存你的飞行身份哦', saveMessageX, saveMessageY)
        ctx.font = `${lineHeight}px ${fontName}`
      }
      return true
    }
    case 12: {
      axisY = drawContent({
        ...params,
        y: 500,
        contents: [
          { content: '过去一年，你加入了' },
          { content: `${annualReport.totalFollowedGroupCount}个`, color: highlightColor },
          { content: '站点，结交了' },
          { content: `${annualReport.totalFollowedEachOtherCount}名`, color: highlightColor },
          { content: '同行，超过' },
          { content: '95%', color: highlightColor },
          { content: '飞行家' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '遇到知心同频的好朋友，就像体验热气球飞行，总能让人留下难忘美好的回忆' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '希望星球不仅帮助你收获成长，也收获宝贵的友情' }],
      })
      if (qrCode) {
        ctx.font = `24px ${fontName}`
        ctx.fillText('扫码生成你的年度报告', qrMessageX, qrMessageY)
        ctx.drawImage(qrCode, qrCodeX, qrCodeY)
        ctx.fillText('长按即可分享或保存你的飞行身份哦', saveMessageX, saveMessageY)
        ctx.font = `${lineHeight}px ${fontName}`
      }
      return true
    }
    case 13: {
      axisY = drawContent({
        ...params,
        y: 500,
        contents: [
          { content: '过去一年，你登录Tale星球' },
          { content: `${annualReport.totalLandingCount}次`, color: highlightColor },
          { content: '，留下' },
          { content: `${annualReport.totalPostCount}个`, color: highlightColor },
          { content: '印记' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '鱼儿水中游，难得空中飞，稀客稀客' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [{ content: '星球诚挚地向你发出邀请，常来看看' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [{ content: '在打破信息孤岛，事半功倍的过程中，我们相伴同行，彼此点亮' }],
      })
      if (qrCode) {
        ctx.font = `24px ${fontName}`
        ctx.fillText('扫码生成你的年度报告', qrMessageX, qrMessageY)
        ctx.drawImage(qrCode, qrCodeX, qrCodeY)
        ctx.fillText('长按即可分享或保存你的飞行身份哦', saveMessageX, saveMessageY)
        ctx.font = `${lineHeight}px ${fontName}`
      }
      return true
    }
    case 14: {
      axisY = drawContent({
        ...params,
        y: 500,
        contents: [
          { content: '过去一年，你登录Tale星球' },
          { content: `${annualReport.totalLandingCount}次`, color: highlightColor },
          { content: '，留下' },
          { content: `${annualReport.totalPostCount}个`, color: highlightColor },
          { content: '印记' },
          { content: '，开启' },
          { content: `${annualReport.totalPostCommentCount}个`, color: highlightColor },
          { content: '对话框' },
          { content: '，送出' },
          { content: `${annualReport.totalPostLikedCount}个`, color: highlightColor },
          { content: '赞' },
        ],
      })
      axisY = drawContent({
        ...params,
        y: axisY + paragraphSpan,
        contents: [{ content: '内向深沉的小飞象，也会有闪闪发光，遨游天际的一天' }],
      })
      axisY = drawContent({
        ...params,
        y: axisY,
        contents: [{ content: "Tale星球诚挚地向你发出邀请：Don't be shy, let's join channel~" }],
      })
      if (qrCode) {
        ctx.font = `24px ${fontName}`
        ctx.fillText('扫码生成你的年度报告', qrMessageX, qrMessageY)
        ctx.drawImage(qrCode, qrCodeX, qrCodeY)
        ctx.fillText('长按即可分享或保存你的飞行身份哦', saveMessageX, saveMessageY)
        ctx.font = `${lineHeight}px ${fontName}`
      }
      return true
    }
    default:
      return true
  }
}

const drawContent = ({
  ctx,
  contents,
  x,
  y,
  width,
  lineHeight,
  lineLimit,
}: {
  ctx: CanvasRenderingContext2D
  contents: { content: string; color?: string }[]
  x: number
  y: number
  width: number
  lineHeight: number
  lineLimit?: number
}) => {
  let axisY = y
  // 原始字符串
  const originContent = contents.map((c) => c.content).join('')
  // 已绘制内容
  let filledContent = ''
  let contentArrayIndex = 0
  let contentIndex = 0
  while (filledContent !== originContent) {
    let axisX = x
    let limit = lineLimit || findCharacterCountPerLine(ctx, originContent.slice().replace(filledContent, ''), width)
    while (limit > 0 && contentArrayIndex < contents.length) {
      const textBlock = contents[contentArrayIndex]

      // textBlock 内容可以完全容纳在当前行
      const handleTextBlock = (handledText: string, color?: string) => {
        filledContent += handledText
        if (color) {
          ctx.fillStyle = color
        } else {
          ctx.fillStyle = 'white'
        }
        ctx.fillText(handledText, axisX, axisY)

        contentArrayIndex++
        contentIndex = 0
        axisX += ctx.measureText(handledText).width
        limit -= handledText.length
      }

      // textBlock 内容部分在当前行
      const handlePartialTextBlock = (handledText: string, color?: string) => {
        filledContent += handledText
        if (color) {
          ctx.fillStyle = color
        } else {
          ctx.fillStyle = 'white'
        }
        ctx.fillText(handledText, axisX, axisY)

        contentIndex += handledText.length
        axisX += ctx.measureText(handledText).width
        limit = 0
      }

      // 当前 textBlock 还没有写完
      if (contentIndex !== 0) {
        const handledText = textBlock.content.slice(contentIndex)
        const color = textBlock.color
        if (handledText.length <= limit) {
          handleTextBlock(handledText, color)
        } else {
          handlePartialTextBlock(handledText.slice(0, limit), color)
        }
      } else {
        // 新的 textBlock
        const handledText = textBlock.content
        const color = textBlock.color
        if (handledText.length <= limit) {
          handleTextBlock(handledText, color)
        } else {
          handlePartialTextBlock(handledText.slice(0, limit), color)
        }
      }
    }
    axisY += lineHeight
  }

  return axisY
}

export const findCharacterCountPerLine = (ctx: CanvasRenderingContext2D, content: string, width: number) => {
  let limit = 22
  while (
    width < ctx.measureText(content.slice(0, limit)).width ||
    width > ctx.measureText(content.slice(0, limit + 1)).width
  ) {
    if (width < ctx.measureText(content.slice(0, limit)).width) {
      limit -= 1
    }

    if (width > ctx.measureText(content.slice(0, limit + 1)).width) {
      if (limit >= content.length) {
        break
      }
      limit += 1
    }
  }
  return limit
}

export const loadFont = once((fontName: string) => {
  // 初始化字体
  const fontFace = new FontFace(fontName, 'url("https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/ARFont.ttf")')
  document.fonts['add'](fontFace)

  fontFace.load()
  return fontFace
})
